import files from "../files/index";

const path = '/v2';

const v2 = (url: string) => () => ({
  files: files(url + path)
})

export default v2;